/**
 * @param date length 8, yyyyMMdd
 * @param time length 4, HHmm
 * @return date object
 * @description 날짜형식의 문자열, 시간형식 문자열을 합해서 일시형식(yyyyMMddHHmmss)의 문자열 반환, 올바른 형식으로 오지 않으면 현재 날짜 반환
 */
export const strToDate = (date : string, time : string) => {
  if(time.length !== 4) return new Date();
  return `${date} ${time.substring(0,2)}:${time.substring(2)}:00`;
}